import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Icons } from "../../../utils/icons";
import { WEEK_DAYS } from "../../../utils";

const FREQUENCY_OPTIONS = [
  { value: "daily", label: "Quotidien" },
  { value: "weekly", label: "Hebdomadaire" },
  { value: "monthly", label: "Mensuel" },
];

export default function RecurrenceCard({ recurrence, onChange, saveError }) {
  const [formData, setFormData] = useState({
    frequency: recurrence?.frequency || "weekly",
    interval: recurrence?.interval || 1,
    week_days: recurrence?.week_days || [],
  });

  useEffect(() => {
    if (recurrence) {
      setFormData({
        frequency: recurrence.frequency || "weekly",
        interval: recurrence.interval || 1,
        week_days: recurrence.week_days || [],
      });
    }
  }, [recurrence]);

  const handleChange = (field, value) => {
    const updatedData = { ...formData, [field]: value };
    setFormData(updatedData);
    onChange?.(updatedData);
  };

  const toggleWeekDay = (dayIndex) => {
    setFormData((prev) => {
      const weekDays = prev.week_days || [];
      const updatedWeekDays = weekDays.includes(dayIndex)
        ? weekDays.filter((d) => d !== dayIndex)
        : [...weekDays, dayIndex].sort((a, b) => a - b);

      const updatedData = { ...prev, week_days: updatedWeekDays };
      onChange?.(updatedData);
      return updatedData;
    });
  };

  const handleStartEditing = () => {
    const initialData = {
      frequency: "weekly",
      interval: 1,
      week_days: [],
    };
    setFormData(initialData);
    onChange?.(initialData);
  };

  // Vue : Pas de récurrence - Bouton pour activer
  if (!recurrence) {
    return (
      <div className="recurrence-empty-state">
        <button
          type="button"
          className="btn btn-secondary btn-block"
          onClick={handleStartEditing}
        >
          <Icons.Add />
          Ajouter une récurrence
        </button>
      </div>
    );
  }

  // Vue : Formulaire d'édition/création
  return (
    <div className="recurrence-form">
      {/* Erreurs globales */}
      {saveError && (
        <div className="alert alert-error">
          <Icons.Warning />
          <span>{saveError}</span>
        </div>
      )}

      {/* Fréquence */}
      <div className="form-group">
        <label htmlFor="frequency">
          Type de récurrence <span className="required">*</span>
        </label>
        <select
          id="frequency"
          className="form-select"
          value={formData.frequency}
          onChange={(e) => handleChange("frequency", e.target.value)}
        >
          {FREQUENCY_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {/* Jours de la semaine (si hebdomadaire) */}
      {formData.frequency === "weekly" && (
        <div className="form-group">
          <label>
            Jours de la semaine <span className="required">*</span>
          </label>
          <div className="days-selector-grid">
            {WEEK_DAYS.map((dayLabel, index) => {
              const dayIndex = index + 1; // 1=Lun, 2=Mar, ..., 7=Dim
              const selected = formData.week_days.includes(dayIndex);
              return (
                <button
                  key={dayIndex}
                  type="button"
                  className={`day-button ${selected ? "selected" : ""}`}
                  onClick={() => toggleWeekDay(dayIndex)}
                >
                  {dayLabel}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

RecurrenceCard.propTypes = {
  recurrence: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  saveError: PropTypes.string,
};
